module.exports='<label class="input-wrapper-checkbox__data" ng-transclude=""></label>';